export default __webpack_public_path__ + "static/media/air-freight.d16ef868.svg";